import {useDispatch, useSelector} from "react-redux";
import React from "react";
import {SelectedBooleanStatusType} from "../../Filters/utils";
import {selectedEnableModeSelectorMonitoring, setSelectedEnableModeMonitoring} from "../Selectors/filtersSliceMonitoring";

export const useSelectedEnabledModeMonitoring = () => {
    const dispatch = useDispatch();
    const enableMode = useSelector(selectedEnableModeSelectorMonitoring);

    const onSelectEnableMode = React.useCallback((selected: SelectedBooleanStatusType) => {
        dispatch(setSelectedEnableModeMonitoring(selected));
    }, [dispatch]);

    return {
        enableMode,
        onSelectEnableMode,
    };
};
